<template>
    <div class="recharge_wrap mt44">
        
        <baseHeader :title="$t('account.manage')"></baseHeader>
        
        <div class="allnum"><span>{{ allNum }}</span> {{ $t('account.withdrawalAccounts') }}</div>
        
        <div class="warp2">
            <div class="item" v-for="i in data">
                <!--                <img :src="require('../images/user/recharge'+i.type+'.png')" alt="">-->
                <div class="item_detail">
                    <p class="user_name ari_font">{{ i.bank }}</p>
                    <p class="user_num">{{ i.account }}</p>
                </div>
                <div class="del" @click="delCard(i.id)"></div>
            </div>
        </div>
        <div class="basic_btn" @click="$router.push('/addcountUsdt')">{{ $t('account.add') }}</div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch'
import baseHeader from "@/components/baseHeader";

export default {
    name: "account",
    data() {
        return {
            allNum: 0,
            data: {}
        };
    },
    components: {
        baseHeader
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.start();
    },
    methods: {
        delCard(id) {
            Fetch('/user/bank_remove', {id: id}).then(() => {
                this.start()
            });
        },
        start() {
            Fetch('/user/my_bank').then(r => {
                this.data = r.data.bank;
                this.allNum = r.data.bank.length;
            })
        }
    }
};
</script>

<style lang="less" scoped>
.allnum {
    margin: 15px auto;
    width: 96%;
    color: white;
    font-size: 0.38rem;
    span{
        font-size: 0.45rem;
        color: rgb(237, 199, 161);
        font-weight: 700;
    }
}

.warp1 {
    padding: 0 20px;
    height: 40px;
    
    p {
        font-size: 14px;
        line-height: 40px;
        color: rgba(0, 0, 0, .8);
        font-weight: bold;
        
        span {
            color: #F03041;
        }
    }
}

.ari_font {
    height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    line-height: 20px;
}

.warp2 {
    width: 96%;
    margin: 12px auto;
    padding: 0 15px;
    background: #2B3864;
    border-radius: 15px;
    
    .item {
        padding: 14px 0 11px 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px solid #ECECEC;
        color: #ffffff;
        &:last-child {
            border-bottom: none;
        }
        
        img {
            width: 30px;
            height: 30px;
        }
        
        .item_name {
            width: 65px;
        }
        
        .item_detail {
            margin-left: 10px;
        }
        
        .user_num {
            height: 17px;
            font-size: 12px;
            font-weight: 600;
            color: #ffffff;
            line-height: 17px;
            margin-top: 10px;
        }
        
        .del {
            width: 20px;
            height: 20px;
            background: url(../images/delete.png) no-repeat center center;
            background-size: 100% 100%;
            margin: 0 8px 0 auto;
        }
    }
}

.basic_btn {
    background: linear-gradient(#fbe4cb, #e7bb90);
    color: #512E20;
    font-weight: 700;
    margin: 50px auto 0 auto;
}
</style>
